import React from "react";
import { useDispatch } from "react-redux";
import ColorPopup from "../../../Shared/ColorPopup";
import MarginBox from "../../../Shared/MarginBox";
import PaddingBox from "../../../Shared/PaddingBox";
import SettingsSlider from "../../../Shared/SettingsSlider";
import SizeBox from "../../../Shared/SizeBox";

function Settings({
  background,
  setProp,
  radius,
  fullWidth,
  handleWidthChange,
  handleBorderRadius,
  handleSpacingChange,
  spacing,
  handleMarginChange,
  margin,
  isApplyMarginOnAllSides,
  isApplyPaddingOnAllSides,
  handleMarginCheckBox = () => {},
  allSideMargin,
  handleSliderMarginChange = () => {},
  handlePaddingCheckBox = () => {},
  allSideSpacing,
  handleSliderPaddingChange = () => {},
  handleChangeBackgroundColor,
  resetBackgroundColor,
  transparency,
  handleTransparencyChange,
  borderSelectedColor,
  handleBorderChange,
  borderWidth,
  resetBorderColor,
  dropShadowColor,
  handleDropShadowChange = () => {},
  handleDropShadowReset = () => {},
}) {
  const handleRadiusChange = (value) => {
    handleBorderRadius(value);
  };

  const dispatch = useDispatch();
  const handleAdjustment = (type, side, operation) => {
    if (type === "padding") {
      const newValue =
        operation === "increase" ? spacing[side] + 1 : spacing[side] - 1;
      if (newValue >= 0) handleSpacingChange(side, newValue);
    } else if (type === "margin") {
      const newValue =
        operation === "increase" ? margin[side] + 1 : margin[side] - 1;
      if (newValue >= 0) handleMarginChange(side, newValue);
    }
  };

  return (
    <div>
      <SizeBox fullWidth={fullWidth} handleWidthChange={handleWidthChange} />
      <PaddingBox
        padding={spacing}
        increasePadding={(side) =>
          handleAdjustment("padding", side, "increase")
        }
        decreasePadding={(side) =>
          handleAdjustment("padding", side, "decrease")
        }
        isApplyPaddingOnAllSides={isApplyPaddingOnAllSides}
        handlePaddingCheckBox={handlePaddingCheckBox}
        allSideSpacing={allSideSpacing}
        handleSliderPaddingChange={handleSliderPaddingChange}
        handleSpacingChange={handleSpacingChange}
      />
      <div style={{ marginTop: "10px" }}></div>

      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment("margin", side, "increase")}
        decreaseMargin={(side) => handleAdjustment("margin", side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        handleMarginCheckBox={handleMarginCheckBox}
        allSideMargin={allSideMargin}
        handleSliderMarginChange={handleSliderMarginChange}
        fullWidth={fullWidth}
        handleMarginChange={handleMarginChange}
      />
      <SettingsSlider
        title="Corner Rounding"
        sliderValue={radius}
        onValueChange={handleRadiusChange}
      />
      <ColorPopup
        background={background}
        handleChangeBackgroundColor={handleChangeBackgroundColor}
        resetBackgroundColor={resetBackgroundColor}
        sliderValue={transparency}
        sliderChange={handleTransparencyChange}
        sliderBoxTitle={"Opacity"}
        showSuggestedColorPalette={true}
      />

      <div style={{ marginTop: "10px" }}></div>
      <ColorPopup
        title={"Border"}
        background={borderSelectedColor}
        handleChangeBackgroundColor={(value) =>
          handleBorderChange("color", value)
        }
        resetBackgroundColor={resetBorderColor}
        sliderValue={borderWidth}
        sliderChange={(value) => handleBorderChange("width", value)}
        sliderBoxTitle={"Border Width"}
        sliderMaxValue={8}
        sliderSymbol={"px"}
        showSuggestedColorPalette={true}
        isBorderSlider
      />

      <div style={{ marginTop: "10px" }}></div>
      <ColorPopup
        title="Drop Shadow"
        background={dropShadowColor}
        handleChangeBackgroundColor={(val) => handleDropShadowChange(val)}
        resetBackgroundColor={() => handleDropShadowReset()}
        showSlider={false}
        isHideGradient={true}
        showSuggestedColorPalette={true}
      />
    </div>
  );
}

export default Settings;
